module.exports = __webpack_public_path__ + "img/ko_KR.1096139.webp";